import qs from 'qs'
import axios from 'axios'

import {
	mapActions,
	mapMutations
} from 'vuex'

import {
	Modal,
	Input,
	DIV,
	Switch
} from 'iview'

export default{
	data() {
		return {
			headerWidth: 0
		}
	},
	methods:{
		...mapActions([
			'getNavLogo',
			'getFooterLogo',
			'getGeneralSetting',
			
		]),
		getPageSetup() {
			this.$post(this.domain.dataRealization + 'pageSetup/getPageSetup', qs.stringify({
				channelCode: window.channel,
				setupType: 7
			})).then(res => {
				var setupContent = JSON.parse(res.data.content.setupContent)
				this.logo = setupContent.appraise.imgPath
				const generalSetting = setupContent
				this.getGeneralSetting({
					generalSetting
				})
		
			})
		},
		
		
	}
	
	
}